module.exports = __webpack_public_path__ + "img/management_icon.45c5306e.png";